<a id="hk_nav_close" class="hk-nav-close">
    <span class="feather-icon"><i data-feather="x"></i></span></a>
<div class="nicescroll-bar">
    <div class="navbar-nav-wrap">
        <nav class="navbar navbar-tr blocked-menu">

            <ul class="navbar-nav flex-column mt-20">
                <!--            customer page menu-->

                @if (!isAdmin && hasPermissionSection('tasks')) {
                <li class="nav-item nnav">
                    <a [routerLink]="['tasks']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1 menu-link-spaced">
                        <div class="d-flex align-items-center">
                            <img src="assets/img/menu/tasks.svg" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.tasks' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.tasks</span>
                        </div>
                    </a>
                </li>
                }
                @if (!isAdmin && hasPermission('operational:issues:view')) {
                <li class="nav-item nnav">
                    <a [routerLink]="['operational-issues']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1 menu-link-spaced">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-exclamation-triangle" style="width:20px"
                               [pTooltip]="isNavbarMinimized ? 'Operational Issues' : ''"
                               tooltipStyleClass="tooltip-class"></i>
                            <span class="nav-link-text">Operational Issues</span>
                        </div>
                    </a>
                </li>
                }
                @if (!isAdmin && hasPermissionSection('reports')) {
                <li class="nav-item nnav">
                    <a id="reports-submenu" [class.active]="isReportsActive"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img src="assets/img/menu/report.svg" width="20" class="me-2"
                                 [pTooltip]="isNavbarMinimized ? ('menu.reports' | translate): ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.reports</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level" aria-labelledby="reports-submenu">
                        @if (hasPermission('transaction:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/transaction-history']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rla="routerLinkActive" translate>
                                transaction.history
                            </a>
                        </li>
                        }
                        @if (hasPermission('turnover:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/turnover']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rlac="routerLinkActive" translate>
                                menu.turnover
                            </a>
                        </li>
                        }
                        @if (hasPermission('balancesheet:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/balance-sheet']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rlac1="routerLinkActive" translate>
                                menu.balance_sheet
                            </a>
                        </li>
                        }
                        @if (hasPermission('off:balancesheet:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/off-balance-turnover']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rlac2="routerLinkActive" translate>
                                menu.off_balance_turnover
                            </a>
                        </li>
                        }
                        @if (hasPermission('off:balancesheet:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/off-balance-transaction-history']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rlac2="routerLinkActive" translate>
                                menu.off_balance_transaction_history
                            </a>
                        </li>
                        }
                        
                        @if (hasPermission('deposit:report:summary')) { 
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-deposits']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sod="routerLinkActive"
                               translate>
                                summary.deposits.title
                            </a>
                        </li>
                        }
                        
                        @if (hasPermission('deposit:report:operation:summary')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-deposit-operations']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sodo="routerLinkActive"
                               translate>
                                summary.deposit_ope.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('loan:summary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-loans']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sol="routerLinkActive" translate>
                                summary.loans.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('loan:opsummary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-loan-operations']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #solo="routerLinkActive" translate>
                                summary.loan_ope.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('loan:summary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-loan-classifications']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #solc="routerLinkActive" translate>
                                loans.summary_of_loan_classifications
                            </a>
                        </li>
                        }
                        @if (hasPermission('saveagreement:summary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-savings']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sos="routerLinkActive" translate>
                                summary.savings.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('saveagreement:opsummary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-saving-operations']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #soso="routerLinkActive" translate>
                                summary.saving_ope.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('collaterals:summary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-collaterals']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #soc="routerLinkActive" translate>
                                summary.collaterals.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('collaterals:opsummary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-collateral-operations']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #soco="routerLinkActive" translate>
                                summary.collateral_ope.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('guarantees:summary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-guarantee']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sog="routerLinkActive" translate>
                                summary.guarantees.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('guarantees:opsummary:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['summary-of-guarantee-operations']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #sogo="routerLinkActive" translate>
                                summary.guarantee_ope.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('reports:imported-data:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['imported-data']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #imported="routerLinkActive" translate>
                                menu.imported-data
                            </a>
                        </li>
                        }
                        @if (hasPermission('exported:data:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['exported-data']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               class="nav-link">Exported data</a></li>
                        }
                    </ul>
                </li>
                }

                  @if (!isAdmin && hasPermission('loan:view')) {
                               <li class="nav-item nnav" *ngIf="!isAdmin && hasPermission('loan:view')">
                   <a [routerLink]="['/user/loan-list']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}"
                       class="nav-link d-flex align-items-center pt-1 pb-1"
                       href="javascript:void(0);" style="width: 100%; justify-content: space-between;">
                       <div class="d-flex align-items-center">
                           <img src="assets/img/menu/loan.svg" width="20"
                            [pTooltip]="isNavbarMinimized ? ('menu.loans' | translate) : ''" tooltipStyleClass="tooltip-class">
                           <span class="nav-link-text" translate>tasks.loans</span>
                       </div>
                   </a>
                </li> 

            }

                @if (!isAdmin && hasPermissionSection('orders')) {
                <li class="nav-item nnav">
                    <a id="orders" [class.active]="isOrdersActive"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img src="assets/img/menu/orders.svg" class="" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.orders' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.orders</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level" aria-labelledby="orders">
                        @if (hasPermission('memorialorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/memorial-orders']" [routerLinkActive]="['active']" class="nav-link"
                               #rla="routerLinkActive">
                                <span class="nav-link-text" translate>menu.memorial_order</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('cashinorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/cash-in-orders']" [routerLinkActive]="['active']" class="nav-link"
                               #rla1="routerLinkActive">
                                <span class="nav-link-text" translate>menu.cash_in_order</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('cashoutorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/cash-out-orders']" [routerLinkActive]="['active']" class="nav-link"
                               #rla2="routerLinkActive">
                                <span class="nav-link-text" translate>menu.cash_out_order</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('banktransferorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/bank-transfers']" [routerLinkActive]="['active']" class="nav-link"
                               #rla1="routerLinkActive">
                                <span class="nav-link-text" translate>menu.bank_transfer</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('offbalancedebitorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/off-balance-debit-orders']" [routerLinkActive]="['active']"
                               class="nav-link" #rla3="routerLinkActive">
                                <span class="nav-link-text" translate>menu.off_balance_debit_order</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('offbalancecreditorder:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/off-balance-credit-orders']" [routerLinkActive]="['active']"
                               class="nav-link" #rla4="routerLinkActive">
                                <span class="nav-link-text" translate>menu.off_balance_credit_order</span>
                            </a>
                        </li>
                        }
                        @if (hasPermission('exchange:order:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/currency-exchange-orders']" [routerLinkActive]="['active']"
                               class="nav-link" #rla5="routerLinkActive">
                                <span class="nav-link-text" translate>menu.currency_exchange_order</span>
                            </a>
                        </li>
                        }
                    </ul>
                </li>
                }

                @if (!isAdmin && hasPermissionSection('accounts')) {
                <li class="nav-item nnav">
                    <a [routerLink]="['/user/accounts']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1">
                        <img src="assets/img/menu/accounts.svg" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.accounts' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" translate>menu.accounts</span>
                    </a>
                </li>
                }
                @if (!isAdmin && hasPermissionSection('customers')) {
                <li class="nav-item nnav">
                    <a [routerLink]="['/user/customers']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1">
                        <img src="../../../assets/img/menu/customer_managmanet.svg" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.customer_management' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" translate>menu.customer_management</span>
                    </a>
                </li>
                }

                @if (!isAdmin && hasPermission('groups:view')) {
                <li class="nav-item nnav">
                    <a [routerLink]="['/user/groups']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1">
                        <img src="assets/img/menu/groups.svg" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.groups' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" translate>menu.groups</span>
                    </a>
                </li>
                }

                @if (!isAdmin && (hasPermission('operation:view:own') || hasPermission('operation:view:all'))) {
                <li class="nav-item nnav">
                    <a [routerLink]="['/user/operations']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1">
                        <img src="assets/img/menu/cash_desk.svg" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.cash-desk' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" translate>menu.cash-desk</span>
                    </a>
                </li>
                }
                @if (!isAdmin && (hasPermission('currency:exchange:view') || hasPermission('currency:view'))) {
                <li class="nav-item nnav">
                    <a [routerLink]="['/user/exchange']" [routerLinkActive]="['active']"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link d-flex align-items-center pt-1 pb-1">
                        <img src="../../../assets/img/menu/exchange_rate.svg" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.exchange_rates' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" translate>menu.exchange_rates</span>
                    </a>
                </li>
                }


                @if (!isAdmin && (hasPermission('loanTemplate:view') || hasPermission('saveagreementTemplate:view') || hasPermission('deposit:template:view')||
                hasPermission('operation:commission:view'))) {
                <li class="nav-item nnav">
                    <a id="products" [ngClass]="{'active': isProductsActive}"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img [src]="products" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.products' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.products</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level" aria-labelledby="products">
                        @if (hasPermission('loanTemplate:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/loans']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #plt="routerLinkActive" translate>
                                menu.loan_templates
                            </a>
                        </li>
                        }

                        @if (hasPermission('saveagreementTemplate:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/saving-products']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #prod3="routerLinkActive" translate>
                                menu.saving_products
                            </a>
                        </li>
                        }
                        
                        @if (hasPermission('deposit:template:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/deposit-products']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #prod5="routerLinkActive"
                               translate>
                                menu.deposit_products
                            </a>
                        </li>
                        }
                        @if (hasPermission('operation:commission:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/commission-settings']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #prod4="routerLinkActive" translate>
                                menu.fees
                            </a>
                        </li>
                        }
                    </ul>
                </li>
                }

                @if (!isAdmin && hasPermissionSection('settings')) {
                <li class="nav-item nnav">
                    <a id="user-sett-c" [class.active]="isSettingsActive"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img src="assets/img/menu/settings.svg" class="" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.settings' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.settings</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level" aria-labelledby="user-sett">
                        @if (!isAdmin && hasPermission('banking:day:change')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/operations-day']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #bday="routerLinkActive" translate>
                                menu.operations_day
                            </a>
                        </li>
                        }
                        @if (hasPermission('job:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/jobs']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rla8="routerLinkActive" translate>
                                job.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('accountType:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/chart-of-accounts']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" #rla="routerLinkActive" class="nav-link" translate>
                                menu.coa
                            </a>
                        </li>
                        }
                        @if (hasPermission('loan:note:view') || hasPermission('saving:note:view') ||
                        hasPermission('customer:note:view') ||
                        hasPermission('collateral-note:view') || hasPermission('guarantee-note:view')||
                        hasPermission('deposit:note:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/notes']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" #rla1="routerLinkActive" class="nav-link" translate>
                                common.notes
                            </a>
                        </li>
                        }
                        @if (hasLinkedAccountsPermission()) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/linked-accounts']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #linka="routerLinkActive" translate>
                                linked_accounts.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('printingforms:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/printing-forms']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #rla9="routerLinkActive" translate>
                                menu.print_forms
                            </a>
                        </li>
                        }
                       
                        @if (hasPermission('loan:note:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/user/loan-provisioning']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #prov="routerLinkActive" translate>
                                loan-provision.menu
                            </a>
                        </li>
                        }
                    </ul>
                </li>
                }

            </ul>
        </nav>

        <!--            admin page menu-->
        @if (isAdmin) {
        <nav class="navbar navbar-tr blocked-menu">
            <ul class="navbar-nav flex-column mt-20 pl-1">
                @if (isSuperAdmin || hasPermission('user:view')) {
                <li class="nav-item nnav admin-menu">
                    <a [routerLink]="['/admin/users']" class="nav-link text-left"
                       #rla="routerLinkActive" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <img [src]="rla.isActive ? userManagementIconActive : userManagementIcon" class="" width="22"
                             [pTooltip]="isNavbarMinimized ? ('menu.user_management' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" [class.active-menu-text]="rla.isActive" translate>
                            menu.user_management
                        </span>
                    </a>
                </li>
                }
                @if (isSuperAdmin || hasPermission('permission:group:view')) {
                <li class="nav-item nnav admin-menu">
                    <a [routerLink]="['/admin/roles']" #rol="routerLinkActive" routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left">
                        <img [src]="rol.isActive ? accessIconActive : accessIcon" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.roles' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" [class.active-menu-text]="rol.isActive"
                              translate>menu.roles</span>
                    </a>
                </li>
                }
                @if (hasAdminPermissions()) {
                <li class="nav-item nnav admin-menu">
                    <a [routerLink]="['settings/kyc']" routerLinkActive="active"
                       [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left" #kyc="routerLinkActive" translate>
                        <img [src]="kyc.isActive ? kycIconActive : kycIcon" class="" width="20"
                             [pTooltip]="isNavbarMinimized ? ('menu.kyc' | translate) : ''"
                             tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" [class.active-menu-text]="kyc.isActive"
                              translate>menu.kyc</span>
                    </a>
                </li>
                }
                @if (hasAdminProductsPermission()) {
                <li class="nav-item nnav">
                    <a id="products-a" [ngClass]="{'active': isProductsActive}"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced"
                       data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img [src]="products" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.products' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.products</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level" aria-labelledby="products">
                        @if (hasPermission('loanTemplate:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/admin/loans']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #plt="routerLinkActive" translate>
                                menu.loan_templates
                            </a>
                        </li>
                        }

                        @if (hasPermission('saveagreementTemplate:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/admin/saving-products']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #prds="routerLinkActive" translate>
                                menu.saving_products
                            </a>
                        </li>
                        }
                        @if (hasPermission('deposit:template:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/admin/deposit-products']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #depos="routerLinkActive"
                               translate>
                                menu.deposits
                            </a>
                        </li>
                        }
                        @if (hasPermission('operation:commission:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/admin/commission-settings']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #cmm="routerLinkActive" translate>
                                menu.fees
                            </a>
                        </li>
                        }
                    </ul>
                </li>
                }
                @if (hasPermission('branch:view')) {
                <li class="nav-item nnav admin-menu">
                    <a [routerLink]="['settings/branch-network']" class="nav-link text-left"
                       [routerLinkActive]="['active']" #brl="routerLinkActive"
                       [routerLinkActiveOptions]="{exact: true}">
                        <img [src]="brl.isActive ? branchesIconActive : branchesIcon" class="" width="22"
                             pTooltip="{{'branch.title-list' | translate}}" tooltipStyleClass="tooltip-class">
                        <span class="nav-link-text" [class.active-menu-text]="brl.isActive"
                              translate>branch.title-list</span>
                    </a>
                </li>
                }
                @if (hasAdminSettingsPermission()) {
                <li class="nav-item nnav">
                    <a id="user-sett" [class.active]="isSettingsActive"
                       class="nav-link dropdown-toggle has-sub d-flex align-items-center menu-link-spaced" data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="d-flex align-items-center">
                            <img src="assets/img/menu/settings.svg" class="" width="20"
                                 [pTooltip]="isNavbarMinimized ? ('menu.settings' | translate) : ''"
                                 tooltipStyleClass="tooltip-class">
                            <span class="nav-link-text" translate>menu.settings</span>
                        </div>
                        <i class="fa fa-angle-down"></i>
                    </a>
                    <ul class="dropdown-menu navbar-tr sub-menu-level text-left" aria-labelledby="admin-settings">
                        @if (hasPermission('banking:day:change')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/operations-day']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #bday="routerLinkActive" translate>
                                menu.operations_day
                            </a>
                        </li>
                        }
                        @if (hasPermission('currency:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['/admin/currencies']" class="nav-link"
                               #curr="routerLinkActive" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" translate>
                                menu.currencies
                            </a>
                        </li>
                        }
                        @if (hasPermission('job:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/jobs']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #job="routerLinkActive" translate>
                                job.title
                            </a>
                        </li>
                        }
                        @if (hasPermission('accountType:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/chart-of-accounts']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #sett1="routerLinkActive" translate>
                                menu.coa
                            </a>
                        </li>
                        }
                        @if (hasAdminNotesPermission()) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/notes']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #not="routerLinkActive" tooltipStyleClass="tooltip-class"
                               translate>
                                common.notes
                            </a>
                        </li>
                        }
                        @if (hasPermission('holiday:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/non-working-days']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #bn="routerLinkActive" tooltipStyleClass="tooltip-class"
                               translate>
                                menu.non_working_days
                            </a>
                        </li>
                        }
                        @if (hasPermission('cash:desk:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/cash-desk']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #desk="routerLinkActive" translate>
                                menu.cash-desk
                            </a>
                        </li>
                        }
                        @if (hasLinkedAccountsPermission()) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/linked-accounts']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #la="routerLinkActive" translate>
                                linked_accounts.title
                            </a>
                        </li>
                        }
                        <!-- @if (hasPermission('company:view')) { -->
                        <li class="nav-item">
                            <a [routerLink]="['settings/company-details']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #comp="routerLinkActive" translate>
                                company.title
                            </a>
                        </li>
                        <!-- } -->
                        @if (hasPermission('printingforms:view')) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/printing-forms']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #cad="routerLinkActive" translate>
                                menu.print_forms
                            </a>
                        </li>
                        }
                        @if (hasAdminPermissions()) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/risk-classification-library']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link text-left"
                               #risk="routerLinkActive" translate>
                                risks.classification-title
                            </a>
                        </li>
                        }
                        @if (hasAdminNotificationsPermission()) {
                        <li class="nav-item">
                            <a [routerLink]="['settings/notifications']" [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}" class="nav-link" #cad="routerLinkActive" translate>
                                menu.notifications
                            </a>
                        </li>
                        }
                    </ul>
                </li>
                }
                <!--          end of admin page menu-->
            </ul>
        </nav>
        }

    </div>
</div>
